<template>
  <div class="settings">
    <!-- Loading Overlay -->
    <v-overlay :model-value="loading" class="align-center justify-center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-overlay>

    <v-row>
      <v-col cols="12">
        <v-card elevation="2">
          <v-card-title class="pb-2">
            <v-icon icon="mdi-cog" class="mr-2"></v-icon>
            Cài đặt hệ thống
          </v-card-title>
          <v-card-text class="pt-4">
            <v-form ref="settingsForm" @submit.prevent="updateSettings">
              <v-row>
                <!-- Site Information -->
                <v-col cols="12">
                  <div class="text-h6 mb-3 text-primary">
                    <v-icon icon="mdi-web" class="mr-2"></v-icon>
                    Thông tin website
                  </div>
                </v-col>
                
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="configs.site_name"
                    label="Tên website"
                    variant="outlined"
                    density="compact"
                    prepend-inner-icon="mdi-web"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="configs.site_keyword"
                    label="Từ khóa SEO"
                    variant="outlined"
                    density="compact"
                    prepend-inner-icon="mdi-tag"
                  ></v-text-field>
                </v-col>
                
                <v-col cols="12">
                  <v-textarea
                    v-model="configs.site_description"
                    label="Mô tả website"
                    variant="outlined"
                    density="compact"
                    prepend-inner-icon="mdi-text"
                    rows="3"
                  ></v-textarea>
                </v-col>

                <!-- Bank Information -->
                <v-col cols="12">
                  <v-divider class="my-4"></v-divider>
                  <div class="text-h6 mb-3 text-primary">
                    <v-icon icon="mdi-bank" class="mr-2"></v-icon>
                    Thông tin ngân hàng
                  </div>
                </v-col>
                
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="configs.bank_name"
                    label="Tên ngân hàng"
                    variant="outlined"
                    density="compact"
                    prepend-inner-icon="mdi-bank"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="configs.bank_account"
                    label="Số tài khoản"
                    variant="outlined"
                    density="compact"
                    prepend-inner-icon="mdi-credit-card"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="configs.bank_holder"
                    label="Chủ tài khoản"
                    variant="outlined"
                    density="compact"
                    prepend-inner-icon="mdi-account"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>

                <!-- Social Media Links -->
                <v-col cols="12">
                  <v-divider class="my-4"></v-divider>
                  <div class="text-h6 mb-3 text-primary">
                    <v-icon icon="mdi-share-variant" class="mr-2"></v-icon>
                    Liên kết mạng xã hội
                  </div>
                </v-col>
                
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="configs.youtube_link"
                    label="Link YouTube"
                    variant="outlined"
                    density="compact"
                    prepend-inner-icon="mdi-youtube"
                    type="url"
                    placeholder="https://youtube.com/..."
                  ></v-text-field>
                </v-col>
                
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="configs.facebook_link"
                    label="Link Facebook"
                    variant="outlined"
                    density="compact"
                    prepend-inner-icon="mdi-facebook"
                    type="url"
                    placeholder="https://facebook.com/..."
                  ></v-text-field>
                </v-col>
                
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="configs.tiktok_link"
                    label="Link TikTok"
                    variant="outlined"
                    density="compact"
                    prepend-inner-icon="mdi-music-note"
                    type="url"
                    placeholder="https://tiktok.com/..."
                  ></v-text-field>
                </v-col>

                <!-- Bot Settings -->
                <v-col cols="12">
                  <v-divider class="my-4"></v-divider>
                  <div class="text-h6 mb-3 text-primary">
                    <v-icon icon="mdi-robot" class="mr-2"></v-icon>
                    Cài đặt Bot
                  </div>
                </v-col>
                
                <v-col cols="12" md="6">
                  <v-switch
                    v-model="botEnableSwitch"
                    label="Kích hoạt Bot"
                    color="primary"
                    density="compact"
                    hide-details
                  ></v-switch>
                </v-col>
                
                <v-col cols="12">
                  <v-textarea
                    v-model="configs.bot_prompt"
                    label="Prompt Bot"
                    variant="outlined"
                    density="compact"
                    prepend-inner-icon="mdi-message-text"
                    rows="4"
                    placeholder="Nhập prompt để hướng dẫn bot..."
                    hint="Hướng dẫn chi tiết về cách bot sẽ tương tác và trả lời khách hàng"
                    persistent-hint
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn
              variant="outlined"
              color="grey"
              @click="resetForm"
              :disabled="loading || updating"
            >
              <v-icon icon="mdi-refresh" class="mr-2"></v-icon>
              Đặt lại
            </v-btn>
            <v-btn
              color="primary"
              variant="elevated"
              @click="updateSettings"
              :loading="updating"
              :disabled="loading"
            >
              <v-icon icon="mdi-content-save" class="mr-2"></v-icon>
              Cập nhật
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Success Snackbar -->
    <v-snackbar
      v-model="showSuccessSnackbar"
      color="success"
      :timeout="3000"
      top
    >
      <v-icon icon="mdi-check-circle" class="mr-2"></v-icon>
      Cập nhật cài đặt thành công!
    </v-snackbar>

    <!-- Error Snackbar -->
    <v-snackbar
      v-model="showErrorSnackbar"
      color="error"
      :timeout="5000"
      top
    >
      <v-icon icon="mdi-alert-circle" class="mr-2"></v-icon>
      {{ errorMessage }}
    </v-snackbar>
  </div>
</template>

<script>
import axios from '@/http';

export default {
  name: 'Setting',
  data() {
    return {
      loading: false,
      updating: false,
      showSuccessSnackbar: false,
      showErrorSnackbar: false,
      errorMessage: '',
      configs: {
        site_name: '',
        site_description: '',
        site_keyword: '',
        bank_name: '',
        bank_account: '',
        bank_holder: '',
        youtube_link: '',
        facebook_link: '',
        tiktok_link: '',
        bot_enable: '0',
        bot_prompt: ''
      },
      rules: {
        required: value => !!value || 'Trường này là bắt buộc'
      }
    };
  },
  
  computed: {
    botEnableSwitch: {
      get() {
        return this.configs.bot_enable === '1';
      },
      set(value) {
        this.configs.bot_enable = value ? '1' : '0';
      }
    }
  },
  
  mounted() {
    this.fetchConfigs();
  },
  
  methods: {
    async fetchConfigs() {
      this.loading = true;
      try {
        const response = await axios.get('/admin/configs');
        
        // Map API response to configs object
        if (response.data && response.data.success && response.data.data) {
          const configsData = response.data.data;
          
          // Update configs with data from API
          Object.keys(configsData).forEach(key => {
            if (this.configs.hasOwnProperty(key)) {
              this.configs[key] = configsData[key] || '';
            }
          });
        }
      } catch (error) {
        console.error('Error fetching configs:', error);
        this.showError('Lỗi khi tải cài đặt. Vui lòng thử lại.');
      } finally {
        this.loading = false;
      }
    },
    
    async updateSettings() {
      // Validate form
      const { valid } = await this.$refs.settingsForm.validate();
      if (!valid) {
        this.showError('Vui lòng điền đầy đủ thông tin bắt buộc.');
        return;
      }
      
      this.updating = true;
      try {
        // Send configs as object directly
        await axios.put('/admin/configs', this.configs);
        
        this.showSuccessSnackbar = true;
      } catch (error) {
        console.error('Error updating configs:', error);
        this.showError('Lỗi khi cập nhật cài đặt. Vui lòng thử lại.');
      } finally {
        this.updating = false;
      }
    },
    
    resetForm() {
      // Reset to empty values with proper types
      Object.keys(this.configs).forEach(key => {
        if (key === 'bot_enable') {
          this.configs[key] = '0';
        } else {
          this.configs[key] = '';
        }
      });
      
      // Clear form validation
      this.$refs.settingsForm.resetValidation();
    },
    
    showError(message) {
      this.errorMessage = message;
      this.showErrorSnackbar = true;
    }
  }
};
</script>

<style scoped>
.settings {
  max-width: 1200px;
  margin: 0 auto;
}

.text-primary {
  color: rgb(var(--v-theme-primary)) !important;
}

.v-card {
  border-radius: 12px;
}

.v-card-title {
  background-color: rgba(var(--v-theme-primary), 0.05);
  border-bottom: 1px solid rgba(var(--v-theme-primary), 0.1);
}

.v-divider {
  margin: 16px 0;
}

/* Form styling */
.v-text-field,
.v-textarea {
  margin-bottom: 8px;
}

/* Section headers */
.text-h6 {
  font-weight: 600;
  display: flex;
  align-items: center;
}

/* Button styling */
.v-btn {
  text-transform: none;
  letter-spacing: 0.5px;
}

/* Snackbar positioning */
.v-snackbar {
  top: 80px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .settings {
    padding: 0 8px;
  }
  
  .v-card-actions {
    flex-direction: column;
    gap: 8px;
  }
  
  .v-btn {
    width: 100%;
  }
}
</style>
